import { Box, Typography } from "@mui/material";
import React, { useEffect, useState, useRef, forwardRef } from "react";
// import { relationships } from "../../../constants/constants";
import { PieChart } from "../../Charts";
import SimpleBarReact from "simplebar-react";
import OtherRelations from "./OtherRelations";

import "./familyTree.scss";
import AddMemberModal from "../../../modals/yourAssets/FT/AddMemberModal";
import {
  getFamilyTree,
  getTotalAuditTrials,
  updateAuditTrials,
} from "../../../services/yourAssets/FamilyTreeServices";
import { BASE_URL, FT_KEY, S3_URL, VERSION } from "../../../constants/ApiUrls";
import EditMemberModal from "../../../modals/yourAssets/FT/EditMemberModal";
import {
  getFTGraphCheck,
  getKeyFromText,
  getUserIdFromLocalStorage,
  setFTGraphCheck,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import TutorialWindow from "./TutorialsWindow";

const FamilyBar = forwardRef((props, ref) => {
  const {
    refreshFromParent,
    isTutorialEnable,
    otherTutorialShow,
    handleOtherTutorialShow,
  } = props;
  const { t } = useTranslation();

  const relationships = [
    { id: 1, name: t("relationship-1"), gender: "male" },
    { id: 2, name: t("relationship-2"), gender: "female" },
    { id: 3, name: t("relationship-3"), gender: "male" },
    { id: 4, name: t("relationship-4"), gender: "female" },
    { id: 5, name: t("relationship-5"), gender: "male" },
    { id: 6, name: t("relationship-6"), gender: "female" },
    { id: 7, name: t("relationship-7"), gender: "male" },
    { id: 8, name: t("relationship-8"), gender: "female" },
    { id: 9, name: t("relationship-9"), gender: "male" },
    { id: 10, name: t("relationship-10"), gender: "female" },
    { id: 11, name: t("relationship-11"), gender: "male" },
    { id: 12, name: t("relationship-12"), gender: "male" },
  ];

  const [addMemberModal, setAddMemberModal] = useState(false);
  const [currentNode, setCurrentNode] = useState({});
  const [defaultValue, setDefaultValue] = useState({});
  const [otherRelationsCard, setOtherRelationsCard] = useState(true);
  const [otherRelationships, setOtherRelationships] = useState([]);
  const [refreshTree, setRefreshTree] = useState(false);
  const [editMemberModal, setEditMemberModal] = useState(false);
  const [chartOptions, setChartOptions] = useState([]);
  const [auditTrialList, setAuditTrialList] = useState([]);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const otherRelationReference = useRef(null);
  const otherRelationInfoReference = useRef(null);

  let uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const getTranslatedRole=(personName) => {
    if (personName === "Father") return "Vater";
    if (personName === "Mother") return "Mutter";
    return personName;
  }
  const getTree = async () => {
    let result = await getFamilyTree(uID);

    let result2 = await getTotalAuditTrials(
      currentConsultantId ? currentConsultantId : uID
    );
    if (result2.status === 204) {
    } else {
      result2 = result2.payLoad;
    }
    let changedObjects = [];
    for (let i = 0; i < result2.length; i++) {
      const elementI = result2[i];
      changedObjects.push(elementI.auditTrailId);

      for (let j = 0; j < result?.familyTree?.length; j++) {
        const elementJ = result?.familyTree[j];
        if (
          elementI.objectName === "UserFamilyTree" &&
          elementI.keyValues.ObjectId === elementJ.familyTreeId
        ) {
          elementJ.shadow = true;
          setAuditTrialList([...auditTrialList, elementI]);
        }
      }
    }
    if (changedObjects.length) {
      await updateAuditTrials(currentConsultantId, changedObjects);
    }

    for (let i = 0; i < result.familyTree.length; i++) {
      const element = result.familyTree[i];
      if (element.gender === "other") {
        element.gender = "female";
      }
      if (
        // element.relationship !== t("relationship-11") &&
        // element.relationship !== t("relationship-12")
        element.relationship !== "Friend" &&
        element.relationship !== "Pet"
      ) {
        element.addNew = "/assets/icons/plus.png";
      }

      if (element.complicatedRelation && !element.isDead) {
        element.isAliveImage = "/assets/icons/bolt.png";
      } else if (element.isAlive && !element.complicatedRelation) {
        element.isAliveImage = "/assets/icons/cross.png";
      } else if (element.complicatedRelation && element.isDead) {
        element.isAliveImage = "/assets/icons/cross.png";
      }
      if (
        element.firstName &&
        element.dateOfBirth &&
        // (element.relationship === t("relationship-11") ||
        //   element.relationship === t("relationship-12"))
        element.relationship === "Friend" &&
        element.relationship === "Pet"
      ) {
        element.edit = "/assets/icons/tick.png";
      } else {
        element.edit = "/assets/icons/edit.png";
      }

      if (!element.pictureId) {
        switch (element.relationship) {
          case "Pet":
            // t("relationship-11")
            element.profilePicture = "/assets/icons/pet.png";
            break;
          case "Friend":
            // t("relationship-12")
            element.profilePicture = "/assets/icons/friend.png";
            break;

          default:
            break;
        }
      } else {
        element.profilePicture =
          BASE_URL +
          FT_KEY +
          VERSION +
          uID +
          "/familytree-image?familyTreeImageId=" +
          element.pictureId;
      }
    }
    let others = result?.familyTree.filter(
      (item) =>
        item.relationship === t("relationship-11") ||
        item.relationship === t("relationship-12") ||
        item.relationship === "Pet" ||
        item.relationship === "Friend"
    );

    let colors = ["#6b607e", "#444561", "#c298bb", "#957BA0"];
    let tempArr = [
      {
        personName: "Pending",
        personAmount: 0,
      },
      {
        personName: "aaa",
        personAmount: 50000,
      },
      {
        personName: "bbb",
        personAmount: 50000,
      },
    ];
    let chartOpt = result?.inheritanceShares?.map((el, i) => {
      return {
        role: getTranslatedRole(el.personName),
        color: colors[i % 4],
        series: el.personShares,
      };
    });

    setChartOptions(chartOpt);
    setRefreshTree(false);
    setOtherRelationships([...others]);
    setFTGraphCheck(false);
  };
  useEffect(() => {
    getTree();
  }, []);
  useEffect(() => {
    if (getFTGraphCheck()) getTree();
  }, [getFTGraphCheck()]);
  useEffect(() => {
    if (refreshTree) getTree();
  }, [refreshTree]);
  useEffect(() => {
    if (refreshFromParent) getTree();
  }, [refreshFromParent]);

  const handleClick = (item, key) => {
    setCurrentNode(JSON.parse(JSON.stringify(item)));
    for (let i = 0; i < relationships.length; i++) {
      const element = relationships[i];
      if (element.name === item.relationship) {
        setDefaultValue(element);
      }
    }
    if (key === "edit") {
      setEditMemberModal(true);
    } else if (key === "add") {
      setAddMemberModal(true);
    }
  };
  const handleCloseModal = () => {
    handleOtherTutorialShow(false);
  };
  useEffect(() => {
    if (isTutorialEnable) {
      const div2Element = otherRelationReference.current;
      const div3Element = otherRelationInfoReference.current;
      setModalPosition({
        top:
          div2Element.getBoundingClientRect().top -
          div3Element.offsetHeight -
          15,
        //"px",
        left:
          div2Element.getBoundingClientRect().left +
          //   div3Element.getBoundingClientRect().offsetWidth +
          // 100+
          "px",
        // -
        //div3Element.offsetWidth +
        // + 100 +
        // "px",
      });
      handleOtherTutorialShow(true);
    } else {
      handleOtherTutorialShow(false);
    }
  }, [isTutorialEnable]);
  const style = {
    position: "absolute",
    top: 0,
    right: 0,
    width: "15px",
    cursor: "pointer",
  };
  const otherRelations = [
    {
      id: 11,
      name: t("relationship-11"),
      image: "pet.png",
    },
    {
      id: 12,
      name: t("relationship-12"),
      image: "friend.png",
    },
  ];
  return (
    <>
      <Box component="div" className="other-relations">
        <Box
          component="div"
          className="card-nav"
          sx={{ position: "relative" }}
          ref={ref}
        >
          <Typography
            variant="inherit"
            ref={otherRelationReference}
            sx={{ padding: "10px", fontSize: "15px" }}
          >
            {t("rm-type-7")}
          </Typography>
          <Box component="div" className="relations-head">
            {otherRelations?.map((item, index) => (
              <Box component="div" sx={{ position: "relative" }} key={index}>
                <img
                  src="/assets/icons/plus.png"
                  alt="add"
                  style={style}
                  onClick={() => handleClick(item, "add")}
                />
                <img
                  src={"/assets/icons/" + item.image}
                  alt={item.name}
                  className="user-image"
                />
              </Box>
            ))}
          </Box>
          <img
            src="/assets/icons/down-arrow-1.png"
            alt="pet"
            className={
              otherRelationsCard ? "card-handle rotate-img" : "card-handle"
            }
            onClick={() => {
              setOtherRelationsCard(!otherRelationsCard);
            }}
          />
        </Box>
        <Box
          component="div"
          className="main-section"
          sx={{
            display: otherRelationsCard ? "block" : "none",
          }}
        >
          <SimpleBarReact style={{ height: "100%" }} autoHide={false}>
            <OtherRelations list={otherRelationships} click={handleClick} />
          </SimpleBarReact>
        </Box>
      </Box>
      <PieChart options={chartOptions} />

      <EditMemberModal
        open={editMemberModal}
        handleClose={() => {
          setEditMemberModal(false);
        }}
        defaultValue={defaultValue}
        currentNode={currentNode}
        enableSelection={true}
        refresh={() => {
          setRefreshTree(true);
        }}
        userId={uID}
      />

      <AddMemberModal
        open={addMemberModal}
        handleClose={() => {
          setAddMemberModal(false);
        }}
        currentNode={currentNode}
        defaultValue={defaultValue}
        enableSelection={true}
        refreshTree={() => {
          setRefreshTree(true);
        }}
        userId={uID}
      />
      <TutorialWindow
        screenId="other-relation-add"
        reference={otherRelationInfoReference}
        open={otherTutorialShow}
        onClose={handleCloseModal}
        modalPosition={modalPosition}
        message={t("ft-tutorials.other")}
        currentStep="4"
        arrowPosition="bottom"
      />
    </>
  );
});

export default FamilyBar;
